import React from 'react';
import { useLocation } from 'react-router-dom';

import BackOfficeUserCreateButton from 'components/buttons/BackOfficeUserCreateButton';
import BackOfficeFilterDrawer from 'components/drawers/BackOfficeFilterDrawer';
import BackOfficeUserCreateDrawer from 'components/drawers/BackOfficeUserCreateDrawer';
import BackOfficeUserEditDrawer from 'components/drawers/BackOfficeUserEditDrawer';
import BackOfficeSection from 'components/features/backOffice/BackOfficeSection';
import BackOfficeUserFilterForm from 'components/forms/BackOfficeUserFilterForm';
import BackOfficeUsersRequest from 'components/requests/BackOfficeUsersRequest';
import BackOfficeUsersTable from 'components/tables/BackOfficeUsersTable';
import { FilterSetName } from 'store/modules/routerUtils/types';
import { useApplyCachedSearchParams } from 'utils/Router/use-apply-cached-search-params';

function BackOfficeUsers(): JSX.Element {
  const { pathname } = useLocation();
  useApplyCachedSearchParams(pathname);
  return (
    <BackOfficeSection
      actions={<BackOfficeUserCreateButton />}
      table={<BackOfficeUsersTable />}
      filterSetName={FilterSetName.BACK_OFFICE_USERS}
      searchInputPlaceholder="Search Users"
    >
      <BackOfficeUsersRequest />
      <BackOfficeUserCreateDrawer />
      <BackOfficeUserEditDrawer />
      <BackOfficeFilterDrawer filterSetName={FilterSetName.BACK_OFFICE_USERS}>
        <BackOfficeUserFilterForm />
      </BackOfficeFilterDrawer>
    </BackOfficeSection>
  );
}

export default BackOfficeUsers;
